import React, {
	ReactNode,
	useCallback,
	useContext,
	useMemo,
	useState,
} from "react";
import { LayoutContext } from "../../contexts/LayoutContext";
import { WorkbenchContext } from "../../contexts/WorkbenchContext";

interface Props {
	children?: ReactNode;
	style?: { [key: string]: string | number | null };
}

function TaskPageTemplate({ children, style }: Props) {
	const [sidebarVisible, setSidebarVisible] = useState(false);

	// Get the workbench details
	const { workbenchIndex } = useContext(WorkbenchContext);

	// Toggle sidebar
	const toggleSidebar = useCallback(
		() => setSidebarVisible(!sidebarVisible),
		[sidebarVisible]
	);

	// Actions to open/close sidebar
	const openSidebar = useCallback(() => setSidebarVisible(true), []);
	const closeSidebar = useCallback(() => setSidebarVisible(false), []);

	// State of the task page layout
	const layout = useMemo(() => {
		return {
			openSidebar,
			closeSidebar,
			toggleSidebar,
			sidebarVisible,
		};
	}, [closeSidebar, openSidebar, sidebarVisible, toggleSidebar]);

	return (
		<div
			className={
				"activity-container activity-sidebar--" +
				(sidebarVisible ? "open" : "closed")
			}>
			<div className="activity-main">
				<div
					className={`workbench-form workbench-form_${workbenchIndex}`}
					style={style}>
					<LayoutContext.Provider value={layout}>
						{children}
					</LayoutContext.Provider>
				</div>
			</div>
			<div className="activity-sidebar">
				<div
					id={`workbench_${workbenchIndex}_sidebar`}
					className="workbench__sidebar-inner"
				/>
			</div>
		</div>
	);
}

export default TaskPageTemplate;
